import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function SingleVerticalAirport() {
  return (
    <div className="single-vertical-parent">
      <div className="vertical-title">
        <div className="text-900 font-bold text-7xl mb-4 text-center">
          FlexNet Airport: Smart Connectivity for Seamless Airport Operations
        </div>
        <div className="text-700 text-xl mb-6 text-center line-height-3">
          Enhance passenger experience, optimize airport logistics, and improve
          safety with advanced 4G/5G-enabled solutions.
        </div>
      </div>
      {/* Hero Section */}
      <div className="grid grid-nogutter surface-section text-800 ">
        <div className="col-12 md:col-6 p-6 text-center md:text-left flex align-items-center">
          <section>
            <span className="block text-6xl font-bold mb-3">FlexNet Port</span>
            <div className="text-6xl text-primary font-bold mb-3">
              Revolutionizing Operations with 5G Connectivity
            </div>
            <p className="mt-0 mb-4 text-700 line-height-3">
              Streamline airport operations with FlexNet Airport. Our high-speed
              4G/5G connectivity ensures real-time monitoring, automated ground
              handling, enhanced passenger services, and efficient resource
              management for modern airports.
            </p>
            <button className="flex underline align-items-center mt-4">
              <Link to="/connectivity">Request Demo</Link>
              <FaExternalLinkAlt className="ml-2" />
            </button>
          </section>
        </div>
        <div className="col-12 md:col-6 overflow-hidden">
          <img
            src="https://www.shutterstock.com/image-photo/diverse-air-traffic-control-team-600nw-1978893014.jpg"
            alt="hero-1"
            className="md:ml-auto block md:h-full"
            style={{ clipPath: "polygon(8% 0, 100% 0%, 100% 100%, 0 100%)" }}
          />
        </div>
      </div>

      {/* Key Benefits Section */}
      <div className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center">
        <div className="mb-3 font-bold text-3xl">
          <span className="text-900">Why </span>
          <span className="text-blue-600">Choose FlexNet Airport?</span>
        </div>
        <div className="grid justify-center">
          {keyBenefits.map((benefit, index) => (
            <div key={index} className="col-12 md:col-4 mb-4 px-5">
              <span
                className="p-3 shadow-2 mb-3 inline-block surface-card"
                style={{ borderRadius: "10px" }}
              >
                <i className={`${benefit.icon} text-4xl text-blue-500`}></i>
              </span>
              <div className="text-900 text-xl mb-3 font-medium">
                {benefit.title}
              </div>
              <span className="text-700 line-height-3">{benefit.detail}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Use Cases Section */}

      <div className="mb-3 font-bold text-3xl">
        <span className="text-900">FlexNet Airport </span>
        <span className="text-blue-600">Use Cases</span>
      </div>
      {useCases.map((useCase, index) => (
        <div
          key={index}
          className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center"
        >
          <div className="b-3 font-bold text-2xl mb-3">
            <span className="text-blue-600">Use Case</span>
            {useCase.title}
          </div>
          <div className="text-700 mb-6">{useCase.description}</div>
          <div className="grid">
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">Benefits</div>
              {useCase.benefits.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">
                Devices/Technologies
              </div>
              {useCase.devices.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">
                Applications
              </div>
              {useCase.applications.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <button className="flex underline align-items-center mt-4 vertical-market-link">
              <Link to="/marketplace">Request Access to Marketplace</Link>
              <FaExternalLinkAlt className="ml-2" />
            </button>
          </div>
        </div>
      ))}

      {/* Case Studies Testimonias Section */}
      <div className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center">
        <div className="mb-3 font-bold text-3xl">
          <span className="text-blue-600"> Key Technical Features</span>
        </div>
        <div className="grid justify-center">
          <div className="text-900 text-xl mb-3 font-medium"></div>
          <div className="technical-specifications">
            <div className="text-700 line-height-3 technical-specifications-box text-xl">
              <ul className="list-disc pl-5 mt-3">
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  High-speed, low-latency 4G/5G connectivity
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Edge computing for real-time processing
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Secure data transmission with encryption protocols
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Seamless integration with airport management systems
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Scalable architecture for small to large airports
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Call-to-Action Section */}
      <div className="surface-section text-center py-8">
        <div className="text-900 text-3xl font-bold mb-4">
          Ready to Transform Your Airport Operations?
        </div>

        <button className="p-button p-button-raised connectivity-request-demo-button p-3">
          <Link to="contact-page">Get in Touch for a Personalized Demo</Link>
        </button>
      </div>
    </div>
  );
}

const keyBenefits = [
  {
    title: "Real-Time Tracking of Baggage, Aircraft, and Ground Vehicles",
    detail:
      "Monitor and manage airport assets efficiently with IoT-enabled tracking.",
    icon: "pi pi-map",
  },
  {
    title:
      "Enhanced Passenger Experience with Smart Services and In-Terminal Wi-Fi",
    detail: "Improve passenger satisfaction with seamless digital services.",
    icon: "pi pi-wifi",
  },
  {
    title: "Automation Support for Ground Handling Equipment (GSE)",
    detail: "Streamline airport logistics with automated ground operations.",
    icon: "pi pi-cog",
  },
  {
    title: "Predictive Maintenance for Airport Infrastructure",
    detail: "Minimize disruptions by anticipating maintenance needs.",
    icon: "pi pi-chart-line",
  },
  {
    title: "Improved Operational Efficiency Through Data-Driven Insights",
    detail: "Leverage analytics to optimize airport processes.",
    icon: "pi pi-chart-bar",
  },
  {
    title:
      "Secure, High-Speed 4G/5G Connectivity Across Airside and Landside Areas",
    detail: "Ensure stable and fast communication for all airport operations.",
    icon: "pi pi-lock",
  },
];

const useCases = [
  {
    title: " 1: Automated Baggage Handling with Robotics",
    description:
      "Deploy 5G-connected autonomous robots and conveyor systems for real-time baggage handling, reducing human intervention and improving accuracy.",
    benefits: [
      {
        title: "Faster baggage processing with fewer errors",
        icon: "pi pi-clock",
      },
      {
        title: "Real-time tracking and monitoring of baggage status",
        icon: "pi pi-map",
      },
      {
        title: "Enhanced operational efficiency during peak hours",
        icon: "pi pi-chart-bar",
      },
    ],
    devices: [
      { title: "Autonomous Robots", icon: "pi pi-microchip " },
      { title: "IoT Sensors", icon: "pi pi-cloud" },
      { title: "5G Gateways", icon: "pi pi-wifi" },
    ],
    applications: [
      { title: "Baggage Handling Automation", icon: "pi pi-briefcase" },
      { title: "Robotics Control", icon: "pi pi-cog" },
    ],
  },
  {
    title: " 2: Airside Operations Automation (Ground Vehicle Management)",
    description:
      "Use 5G for real-time tracking and automation of airside vehicles like fuel trucks, catering vehicles, and tugs to improve ground logistics.",
    benefits: [
      {
        title: "Optimize ground support equipment (GSE) routes",
        icon: "pi pi-directions ",
      },
      {
        title: "Reduce delays caused by inefficient vehicle coordination",
        icon: "pi pi-clock",
      },
      {
        title: "Enable predictive maintenance of ground vehicles",
        icon: "pi pi-chart-line",
      },
    ],
    devices: [
      { title: "AGVs", icon: "pi pi-car" },
      { title: "Fleet Management Systems", icon: "pi pi-server" },
      { title: "5G Modems", icon: "pi pi-wifi" },
    ],
    applications: [
      { title: "Ground Handling Operations", icon: "pi pi-truck " },
      { title: "Airside Vehicle Automation", icon: "pi pi-car " },
    ],
  },
  {
    title: " 3: Smart Surveillance with AI-Powered Video Analytics",
    description:
      "Implement 5G-connected AI cameras for real-time surveillance, facial recognition, and behavioral analytics to enhance airport security.",
    benefits: [
      {
        title: "Rapid detection of security threats",
        icon: "pi pi-exclamation-triangle",
      },
      {
        title:
          "Automated alert systems for crowd control and intrusion detection",
        icon: "pi pi-bell",
      },
      {
        title: "Improved situational awareness with real-time video feeds",
        icon: "pi pi-video",
      },
    ],
    devices: [
      { title: "AI Cameras", icon: "pi pi-camera" },
      { title: "5G Edge Computing Devices", icon: "pi pi-microchip " },
      { title: "Facial Recognition Software", icon: "pi pi-user" },
    ],
    applications: [
      { title: "Perimeter Security", icon: "pi pi-lock" },
      { title: "Crowd Monitoring", icon: "pi pi-users" },
      { title: "Threat Detection", icon: "pi pi-shield" },
    ],
  },
  {
    title: " 4: Digital Twin for Airport Operations",
    description:
      "Use 5G-enabled IoT devices to create a digital twin of the airport, providing real-time data visualization for predictive analysis and resource optimization.",
    benefits: [
      {
        title:
          "Improve operational efficiency through data-driven decision-making",
        icon: "pi pi-chart-bar",
      },
      {
        title: "Simulate emergency scenarios for better preparedness",
        icon: "pi pi-exclamation-triangle",
      },
      {
        title: "Optimize energy consumption and resource allocation",
        icon: "pi pi-lightbulb",
      },
    ],
    devices: [
      { title: "IoT Sensors", icon: "pi pi-cloud" },
      { title: "Digital Twin Platforms", icon: "pi pi-server" },
      { title: "Edge Computing", icon: "pi pi-microchip" },
    ],
    applications: [
      { title: "Airport Management Systems", icon: "pi pi-globe" },
      { title: "Resource Optimization", icon: "pi pi-chart-line" },
    ],
  },
  {
    title: " 5: Predictive Maintenance for Critical Airport Infrastructure",
    description:
      "Utilize real-time data from 5G-connected sensors to predict maintenance needs for runways, terminal equipment, and HVAC systems.",
    benefits: [
      { title: "Minimize downtime and maintenance costs", icon: "pi pi-clock" },
      { title: "Improve equipment lifespan", icon: "pi pi-cog" },
      {
        title: "Ensure operational safety and reliability",
        icon: "pi pi-shield",
      },
    ],
    devices: [
      { title: "IoT Sensors", icon: "pi pi-cloud" },
      { title: "Predictive Analytics Platforms", icon: "pi pi-video " },
      { title: "5G Connectivity", icon: "pi pi-wifi" },
    ],
    applications: [
      { title: "Runway Monitoring", icon: "pi pi-cloud " },
      { title: "Terminal Equipment Maintenance", icon: "pi pi-building" },
    ],
  },
];
